module.exports = __webpack_public_path__ + "img/BTN_Plus.95249737.gif";